// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"e3d92d3b8cb4820f","6790":"b10706cb9c7fe8fb"}[chunkId] + ".css";
};